import type { SolutionGasRsoCalculator } from "../../d";

// THIS FUNCTION DOES THE ACTUAL RSO CALCULATIONS AND RETURNS ALL INTERMEDITATE VALUES FOR POTENTIAL USE IN PB AND BO CALCS
export const solutionGasRsoCalculator: SolutionGasRsoCalculator = params => {
  const {
    gasSpecificGravity,
    oilSpecificGravity,
    temperatureF,
    inSituPressurePSIA,
    reservoirPressurePSIA,
    gasOilRatio
  } = params;

  // D90: =(7.916*10**-4)*(D17**1.541)-(4.561*10**-5)*(D4**1.3911)    -- this is also D94
  const x =
    7.916 * 10 ** -4 * oilSpecificGravity ** 1.541 -
    4.561 * 10 ** -5 * temperatureF ** 1.3911;
  // D92: =(((D3/112.727)+12.34)*(D8**0.8439)*10**D90)**1.73184
  const solutionGasRsoInSitu =
    ((inSituPressurePSIA / 112.727 + 12.34) *
      gasSpecificGravity ** 0.8439 *
      10 ** x) **
    1.73184;
  // D96: =(((D12/112.727)+12.34)*(D8**0.8439)*10**D94)**1.73184
  const solutionGasRsoAtReservoir =
    ((reservoirPressurePSIA / 112.727 + 12.34) *
      gasSpecificGravity ** 0.8439 *
      10 ** x) **
    1.73184;

  return {
    x,
    solutionGasRsoAtReservoir:
      solutionGasRsoAtReservoir > gasOilRatio
        ? gasOilRatio
        : solutionGasRsoAtReservoir,
    solutionGasRsoInSitu:
      solutionGasRsoInSitu > gasOilRatio ? gasOilRatio : solutionGasRsoInSitu
  };
};
